import { MedOrderDetail } from '@absg/api-emr-integration';
import { MedOrderTransactionActivityDetail } from '@absg/api-inventory';
import { ConversionHelper, InventoryDisplay } from '@absg/nim-client-shared';

export class MedOrderDispenseDetail {
  detail: MedOrderDetail;
  configuredAmount?: number;
  configuredUnit?: string;
  dispensedAmount?: number;
  dispensedUnit?: string;
  isSelected: boolean;
  wastedAmount?: number;
  pastDispenses?: MedOrderTransactionActivityDetail[] = [];
  matchingInventoryItems?: InventoryDisplay[] = [];
  routeToHide?: string;

  getMedOrderId(): number {
    if (!this.detail) { return null; }
    return this.detail.medOrderDetailId;
  }

  getComponentName(): string {
    if (!this.detail) { return ''; }
    return this.detail.componentName;
  }

  getInstructions(): string {
    if (!this.detail) { return ''; }
    return this.detail.instructions;
  }

  getMedOrderDoseAmount(): number {
    if (!this.detail) { return null; }
    const result = Number(this.detail.dispenseDose);
    return isNaN(result) ? null : result;
  }

  getMedOrderDoseUnit(): string {
    if (!this.detail) { return ''; }
    return this.detail.doseUnit;
  }

  getDoseDisplayValue(): string {
    if (!this.detail) { return ''; }
    return `${this.getMedOrderDoseAmount()} ${this.getMedOrderDoseUnit()}`;
  }

  getDispensedDisplayValue(): string {
    return `${this.dispensedAmount} ${this.dispensedUnit}`;
  }

  getConfiguredDisplayValue(): string {
    return `${this.configuredAmount} ${this.configuredUnit}`;
  }

  showConfigured(): boolean {
    return this.isConfigured() && this.amountMatched();
  }

  showDispensed(): boolean {
    const result = this.getConvertedDispensedAmount();
    return (result || 0) > 0 && (result || 0) >= (this.getMedOrderDoseAmount() || 0);
  }

  isConfigured(): boolean {
    const result = this.getConvertedConfiguredAmount();
    return (result || 0) > 0;
  }

  amountMatched(): boolean {
    const doseAmount = this.getMedOrderDoseAmount();
    return (doseAmount || 0) > 0 &&
      (this.getConvertedConfiguredAmount() || 0) + (this.getConvertedDispensedAmount() || 0) >= (doseAmount || 0);
  }

  isRemoved(): boolean {
    return this.detail.isRemovedOrder;
  }

  private getConvertedDispensedAmount(): number {
    if (this.dispensedUnit === this.getMedOrderDoseUnit()) {
      return this.dispensedAmount;
    }
    return ConversionHelper.convertQuantityByUnitName(this.dispensedAmount, this.dispensedUnit, this.getMedOrderDoseUnit());
  }

  private getConvertedConfiguredAmount(): number {
    if (this.configuredUnit && this.getMedOrderDoseUnit() &&
      this.configuredUnit.toUpperCase() === this.getMedOrderDoseUnit().toUpperCase()) {
      return this.configuredAmount;
    }
    return ConversionHelper.convertQuantityByUnitName(this.configuredAmount, this.configuredUnit, this.getMedOrderDoseUnit());
  }
}
